// Generated by purs version 0.15.0
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var Table = function (x) {
    return x;
};
var eqDineInLocation = {
    eq: function (x) {
        return function (y) {
            return x.number === y.number;
        };
    }
};
var newtypeDineInLocation = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldDineInLocation = function (dictHasField) {
    return dictHasField;
};
var genericDineInLocation = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showDineInLocation = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericDineInLocation)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "number";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showInt))))({
        reflectSymbol: function () {
            return "Table";
        }
    }))
};
var unscrambleDecodeDineInLocation = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecodeTagged(genericDineInLocation)(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "Table";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "number";
        }
    })(Unscramble.decodeInt1)(Unscramble.decodeRecordNil))))(Unscramble_Generic.defaultOptions)
};
var encodingOpts = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        unwrapSingleRecordArguments: true,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    };
})();
var encodeDineInLocation = /* #__PURE__ */ (function () {
    return {
        encode: Foreign_Generic.genericEncode(genericDineInLocation)(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "Table";
            }
        })(Foreign_Generic_Class.genericEncodeArgsRecord(Foreign_Generic_Class.encodeWithOptionsRecord()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
            reflectSymbol: function () {
                return "number";
            }
        })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))))({
            sumEncoding: encodingOpts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: encodingOpts.unwrapSingleArguments,
            unwrapSingleRecordArguments: encodingOpts.unwrapSingleRecordArguments,
            fieldTransform: encodingOpts.fieldTransform
        })
    };
})();
var decodeDineInLocation = /* #__PURE__ */ (function () {
    return {
        decode: Foreign_Generic.genericDecode(genericDineInLocation)(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "Table";
            }
        })(Foreign_Generic_Class.genericDecodeArgsRecord(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
            reflectSymbol: function () {
                return "number";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))({
            sumEncoding: encodingOpts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: encodingOpts.unwrapSingleArguments,
            unwrapSingleRecordArguments: encodingOpts.unwrapSingleRecordArguments,
            fieldTransform: encodingOpts.fieldTransform
        })
    };
})();
export {
    Table,
    encodingOpts,
    genericDineInLocation,
    showDineInLocation,
    eqDineInLocation,
    decodeDineInLocation,
    unscrambleDecodeDineInLocation,
    encodeDineInLocation,
    newtypeDineInLocation,
    hasFieldDineInLocation
};
//# sourceMappingURL=index.js.map
